import React, {
  useState,
  useEffect,
  useRef,
  useContext
} from "react";
import { valueInRange, displayToNumber } from "./Slider.operations";
import SliderContext from "./SliderContext";
import { ValueInput } from "./Slider.styles";
const SliderInput = ({
  sliderValue,
  id,
  validRange,
  updateSlider,
  handleError,
  className = ""
}) => {
  const { debounceDelay, errorMessage, disabled, formatter } = useContext(SliderContext);
  const debouncedTimeout = useRef(setTimeout(() => {
  }));
  const [value, setValue] = useState(formatter(sliderValue));
  useEffect(() => {
    clearTimeout(debouncedTimeout.current);
    setValue(formatter(sliderValue));
  }, [sliderValue]);
  useEffect(() => {
    return () => {
      clearTimeout(debouncedTimeout.current);
    };
  }, []);
  const selectValue = (event) => {
    handleError("");
    const { target } = event;
    setTimeout(() => target.setSelectionRange(0, 9999), 0);
  };
  const inputSave = ({ target: { value: eventValue } }) => {
    const newValue = displayToNumber(eventValue);
    const validValue = valueInRange(newValue, validRange);
    if (Number.isNaN(validValue)) {
      handleError(errorMessage);
      return;
    }
    updateSlider(validValue, true);
    setValue(formatter(validValue));
  };
  const inputChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    clearTimeout(debouncedTimeout.current);
    debouncedTimeout.current = setTimeout(() => {
      inputSave({ target: { value: newValue } });
    }, debounceDelay);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      inputSave({ target: { value } });
    }
  };
  return /* @__PURE__ */ React.createElement(ValueInput, {
    value,
    onChange: inputChange,
    onFocus: selectValue,
    onBlur: inputSave,
    onKeyDown: handleKeyDown,
    id,
    testId: id,
    className,
    disabled,
    "aria-labelledby": id,
    pattern: "[0-9]*",
    inputMode: "numeric"
  });
};
export default SliderInput;
